import React, { useCallback, useRef } from 'react'
import { FormHandles } from '@unform/core'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'
import { useAuth } from '../../hooks/auth'
import { useToast } from '../../hooks/toast'
import getValidationErros from '../../utlis/getValidationErros'
import logoImg from '../../assets/logo-vertical-white.png'
import { Contanier, Content } from './styles'
import Form, { Input } from '../../components/Form'

interface SingInFormData {
  username: string
  password: string
}

const SignUp = (): JSX.Element => {
  const formRef = useRef<FormHandles>(null)

  const { signIn, backupHistory, setHistory } = useAuth()
  const { addToast } = useToast()
  const history = useHistory()

  const onSubmit = useCallback(
    async (data: SingInFormData) => {
      try {
        formRef.current?.setErrors({})

        const schema = Yup.object().shape({
          username: Yup.string().required('Usuário obrigatório'),
          password: Yup.string().required('Senha obrigatório')
        })

        await schema.validate(data, {
          abortEarly: false
        })

        await signIn({
          username: data.username,
          password: data.password
        })

        // history.push(backupHistory || '/dashboard')
        const a = document.createElement('a')
        a.href = backupHistory || '/dashboard'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        setHistory('')
      } catch (err: any) {
        if (err instanceof Yup.ValidationError) {
          const erros = getValidationErros(err)
          formRef.current?.setErrors(erros)
          return
        }
        if (
          err?.response?.data?.message
            ?.toLowerCase()
            .includes('this user not available to access')
        ) {
          addToast({
            type: 'error',
            title: 'Erro na autenticação',
            description: 'Seu acesso ainda não foi liberado.'
          })
          return
        }
        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: 'Confira seus dados de acesso.'
        })
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [signIn, addToast, history]
  )

  return (
    <Contanier>
      <Content>
        <div className="logo">
          <a href="#">
            <img className="logo-light" src={logoImg} alt="" width="222" />
          </a>
        </div>
        <div className="content">
          <Form onSubmit={onSubmit} className="form">
            <h3 className="form-title font-dark">Autenticação</h3>
            <Input
              className="mb-3"
              autoComplete="off"
              placeholder="Usuário"
              name="username"
              rules={{ required: true }}
            />
            <Input
              type="password"
              autoComplete="off"
              placeholder="Senha"
              name="password"
              rules={{ required: true }}
            />
            <div className="form-actions">
              <button type="submit" className="btn btn-dark">
                Entrar
              </button>
              {/* <div>
                <label
                  htmlFor="remember"
                  className="rememberme check mt-checkbox mt-checkbox-outline"
                >
                  <input
                    type="checkbox"
                    name="remember"
                    id="remember_me"
                    value="1"
                  />
                  Me lembre
                  <span />
                </label>
              </div> */}
            </div>
          </Form>
        </div>
      </Content>
    </Contanier>
  )
}
export default SignUp
